module.exports = __webpack_public_path__ + "static/media/blog1.bfb775f5.jpg";